import React, { useState, useContext, createContext, useEffect } from 'react';
import "./App.css"
import AdminPanel from './components/admin components/AdminPanel'
import { BrowserRouter as Router, Route, Routes, useNavigate, useParams } from "react-router-dom"
import Login from './components/login/login';
import Register from './components/register/register';
import PromoterLogin from './components/promoter/promoterLogin';
import PromoterMain from './components/promoter/PromoterMain';
import Help from './components/login/Help';
import Landing from './components/login/Landing';

export const AppContext = createContext()

function App() {

  const [activeUser, setActiveUser] = useState([])

  const [eventDetails, setEventDetails] = useState([])

  const [artistInfo, setArtistInfo] = useState([])

  const [changesMade, setChangesMade] = useState(0)

  const [promoterUpdates, setPromoterUpdates] = useState(0)

  // Updates the artist data
  useEffect(()=> {
    async function getLatestData(){
      const username = localStorage.getItem("user")
      const response = await fetch(`https://the-paper-pusher.herokuapp.com/checkLogin/${username}`)
      if (!response.ok) {
        const message = `An error has occurred: ${response.statusText}`;
        window.alert(message);
        return;
      }
      setActiveUser(await response.json())
    }
    getLatestData()
  },[changesMade]) 

  // Updates the event data
  useEffect(()=> {
    async function getLatestEventData(){
      const id = sessionStorage.getItem('eventID')
      const response = await fetch(`https://the-paper-pusher.herokuapp.com/checkEventId/${id}`)
      if (!response.ok) {
        const message = `An error has occurred: ${response.statusText}`;
        window.alert(message);
        return;
      }
      setEventDetails(await response.json())
    }
    getLatestEventData()
  },[promoterUpdates]) 


  return (
    <AppContext.Provider value={{activeUser, setActiveUser, setChangesMade, eventDetails, setEventDetails, artistInfo, setArtistInfo, setPromoterUpdates}}>
      <div className="App">
        <Router>
          <Routes>
            <Route exact path="/" element={<Login />} />
            <Route exact path="/home" element={<Landing />} />
            <Route exact path="/register" element={<Register />} />
            <Route exact path="/admin" element={<AdminPanel />} />
            <Route exact path="/help" element={<Help />} />
            <Route exact path="/promoter" element={<PromoterLogin />} />
            <Route exact path="/promoter/home" element={<PromoterMain />} />
          </Routes>
        </Router>
      </div>
    </AppContext.Provider>
  );
}

export default App;
